import React from "react";

const AskForResourcesVideo = ({ subsection, saveProgress }) => {
  const about = (
    <div className="space-y-5 pt-2 pb-6 text-body leading-7 text-[#484848]">
      <p>
        This lesson targets the hidden reasons high performers avoid asking for resources, habit, craft pride, fear of looking weak, comfort in busyness, low ambition, and worry that more people means more chaos. It then lays out a leader style approach to asking: craft a bigger vision, align it to a stakeholder win, prove small wins, and keep the request alive as an ongoing trust building conversation. The shift is from busy hero to scaled impact.
      </p>
    </div>
  );

const transcript = (
  <div className="pt-2 pb-6 space-y-4 text-body leading-7 text-[#323232] overflow-y-scroll font-gotham">
    <p>
      Are you doing 10 people’s work…all by yourself?
    </p>

    <p>
      If so, then you have a problem. And a lot of others like you just don’t{" "}
      <em>ask for resources</em>, and there are some sneaky reasons why:
    </p>

    <ul className="list-disc pl-6 space-y-0.5">
      <li>
        <strong>Not habituated to ask:</strong> It’s not something you normally
        do so you just keep grinding.
      </li>
      <li>
        <strong>Craft pride:</strong> You feel like only you can do it right,
        why share your magic?
      </li>
      <li>
        <strong>Imposter fear:</strong> Asking for help? You’re worried you’ll
        look weak.
      </li>
      <li>
        <strong>Joy of being busy:</strong> Being booked wall-to-wall feels…
        important.
      </li>
      <li>
        <strong>Lack of ambition:</strong> You believe completing the project
        is the goal. But leveling up is about scaling your work and your
        territory.
      </li>
    </ul>

    <p>
      And of course, the classic:{" "}
      <em>More people = more headache.</em>
    </p>

    <p>Sound familiar?</p>

    <p>
      If this is how you are thinking then we need to flip the script. Ask for
      resources like a next-level leader:
    </p>

    <p>
      <strong>Step 1: Craft your vision.</strong>
      <br />
      Imagine unlimited money and people. What would you do differently? Go
      wild.
    </p>

    <p>
      <strong>Step 2: Align it.</strong>
      <br />
      Make it clear how your vision helps your stakeholder shine. “Win for me
      = win for you.”
    </p>

    <p>
      <strong>Step 3: Show small wins.</strong>
      <br />
      Prove you can deliver at a smaller scale. Resources aren’t an
      entitlement, they’re an <em>amplifier</em>.
    </p>

    <p>
      <strong>Step 4: Keep it alive.</strong>
      <br />
      Check in, iterate, refine. This isn’t a one-off ask, it’s a conversation
      that builds trust.
    </p>

    <p>
      Remember: resources are your ammo. Without them, delegation is
      impossible. With them… you can multiply your impact, your team’s output,
      and most importantly your chances of promotion.
    </p>

    <p>
      Stop being a busy hero. Ask for resources. Lead bigger. And yes… enjoy
      delegating without guilt.
    </p>
  </div>
);

  // const relatedLinks = (
  //   <div className="pt-2 pb-6">
  //     <ul className="list-disc list-inside text-body space-y-2">
  //       <li>
  //         <button type="button" className="text-link">
  //           Download Slides
  //         </button>
  //       </li>
  //       <li>
  //         <button type="button" className="text-link">
  //           Reference Reading: Career Transitions Report 2025
  //         </button>
  //       </li>
  //     </ul>
  //   </div>
  // );

  return { about, transcript };
};

export default AskForResourcesVideo;
